import { render, staticRenderFns } from "./NotifichePush.vue?vue&type=template&id=5f85c136&"
import script from "./NotifichePush.vue?vue&type=script&lang=js&"
export * from "./NotifichePush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports